import { useOpenSearchKebabEvents } from 'hooks/events/useOpenSearchKebabEvents';
import { useShareFreightQuery } from 'hooks/queries/useShareFreightQuery';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { useOpenSearchContext } from 'hooks/useOpenSearchContext';
import { useToast } from 'hooks/useToast';
import { TShareFreightProps } from 'open-search/types';
import { TextsSearchTrucker } from '../types';

export function useShareFreightModal() {
  const { isDesktop } = useDeviceSize();

  const {
    freightIdToShare,
    setIsModalShareFreightVisible,
    setIsCardVisible,
    setIsTextFieldFocus,
    setValueInputSearch,
    setFreightIdToShare,
    isModalShareFreightVisible,
    searchTruckerData,
  } = useOpenSearchContext();

  const { addToast } = useToast();
  const { sendKebabEvents } = useOpenSearchKebabEvents();

  const { mutate: mutateShareFreight, isPending: isLoadingShareFreight } = useShareFreightQuery(
    freightIdToShare,
    searchTruckerData?.trucker?.uuid,
    {
      onSuccess: () => {
        addToast({
          type: 'success',
          message: 'O motoristas receberá uma notificação no celular.',
          heading: 'Frete compartilhado',
        });
        sendKebabEvents(searchTruckerData, 'trucker_search_driver_kebab_share_confirmed', 'share', freightIdToShare);
        setIsModalShareFreightVisible(false);
      },
      onError: () => {
        addToast({
          type: 'error',
          message: 'Não foi possível compartilhar o frete com esse motorista.',
          heading: 'Frete não compartilhado',
          buttonOne: {
            size: 'small',
            variant: 'secondary',
            text: 'Tentar novamente',
            onClick: /* istanbul ignore next */ () => mutateShareFreight?.(),
            closeOnClick: true,
          },
        });
        sendKebabEvents(searchTruckerData, 'trucker_search_driver_kebab_share_error', 'share', freightIdToShare);
        setIsModalShareFreightVisible(false);
      },
    }
  );

  const handleShareFreight = () => {
    setIsModalShareFreightVisible(true);
    setIsCardVisible(false);
    setIsTextFieldFocus(false);
    setValueInputSearch('');
    sendKebabEvents(searchTruckerData, 'trucker_search_driver_kebab_share', 'share');
  };

  const handleCloseModalShareFreight = () => {
    setIsModalShareFreightVisible(false);
  };

  const handleFreightSelect = (encodedFreightId: string) => setFreightIdToShare(encodedFreightId);

  const handleOnShareFreight = () => {
    mutateShareFreight();
  };

  const propsShareFreight: TShareFreightProps = {
    buttonProps: {
      states: { textContent: TextsSearchTrucker.textKebabShareFreight },
      events: { onClick: () => handleShareFreight() },
    },
    isOpen: isModalShareFreightVisible,
    onFreightSelect: (encodedFreightId) => handleFreightSelect(encodedFreightId),
    onClose: () => handleCloseModalShareFreight(),
    onShare: () => handleOnShareFreight(),
    truckerIdsToShareFreight: [searchTruckerData?.trucker?.id],
    showShareFreight: isDesktop,
    isShareButtonLoading: isLoadingShareFreight,
  };

  return { propsShareFreight };
}
